
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 32 35","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"stroke":"#111","stroke-width":"2","fill":"none","fill-rule":"evenodd","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M15.888 8.444V34M15.888 1a3.722 3.722 0 110 7.444 3.722 3.722 0 010-7.444zM10.305 14.027h11.166M29.73 24.931C27.142 30.318 21.915 34 15.888 34 9.862 34 4.636 30.318 2.047 24.93"}}),_c('path',{attrs:{"d":"M1 32.139v-7.444h7.444M23.333 24.695h7.444v7.444"}})])])
          )
        }
      }
    